// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";

// mutation types
export const PURGE_AUTH = "PURGE_AUTH";
export const SET_AUTH = "SET_AUTH";
export const SET_ERROR = "setError";
